import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-054b386a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onKeydown"]
const _hoisted_2 = ["id", "checked"]

import {
  ref,
  computed,
  onMounted,
  onUnmounted,
  nextTick,
  watch,
} from "vue";

interface Props {
  leftLabel: string;
  rightLabel: string;
  modelValue: boolean;
}

const containerPadding = 12; // Container left/right padding from CSS
const borderOffset = -8; // Distance from container edge
const textPadding = 13; // Extra padding around text


export default /*#__PURE__*/_defineComponent({
  __name: 'SmartToggleSwitch',
  props: {
    leftLabel: {},
    rightLabel: {},
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const inputId = ref(`toggle-${Math.random().toString(36).substring(2, 11)}`);
const toggleContainer = ref<HTMLElement>();
const leftOption = ref<HTMLElement>();
const rightOption = ref<HTMLElement>();
const slider = ref<HTMLElement>();

const leftWidth = ref(0);
const rightWidth = ref(0);
const containerWidth = ref(0);
function measureOptions() {
  if (!leftOption.value || !rightOption.value || !toggleContainer.value) return;

  // Measure the actual rendered width of each option
  leftWidth.value = leftOption.value.getBoundingClientRect().width;
  rightWidth.value = rightOption.value.getBoundingClientRect().width;
  containerWidth.value = toggleContainer.value.getBoundingClientRect().width;
}

const sliderStyle = computed(() => {
  if (
    leftWidth.value === 0 ||
    rightWidth.value === 0 ||
    containerWidth.value === 0
  ) {
    return {};
  }

  const activeWidth = props.modelValue ? leftWidth.value : rightWidth.value;
  const sliderWidth = activeWidth + textPadding * 2;

  // Calculate absolute positions from container edges
  // Available space inside container (excluding padding)
  const availableWidth = containerWidth.value - containerPadding * 2;

  let translateX = 0;

  if (props.modelValue) {
    // Position slider 4px from left edge of container
    // Calculate offset from center to desired position
    const leftEdgePosition =
      -availableWidth / 2 + borderOffset + sliderWidth / 2;
    translateX = leftEdgePosition;
  } else {
    // Position slider 4px from right edge of container
    // Calculate offset from center to desired position
    const rightEdgePosition =
      availableWidth / 2 - borderOffset - sliderWidth / 2;
    translateX = rightEdgePosition;
  }

  return {
    width: `${sliderWidth}px`,
    transform: `translateX(${translateX}px)`,
  };
});

function toggleValue() {
  emit("update:modelValue", !props.modelValue);
}

onMounted(async () => {
  await nextTick();
  measureOptions();

  // Re-measure on window resize
  window.addEventListener("resize", measureOptions);

  // Re-measure when JOST font loads to fix font loading race condition
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      // Small delay to ensure font rendering is complete
      setTimeout(measureOptions, 50);
    });
  }
});

onUnmounted(() => {
  window.removeEventListener("resize", measureOptions);
});

// Re-measure when labels change
watch([() => props.leftLabel, () => props.rightLabel], async () => {
  await nextTick();
  measureOptions();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["smart-toggle-switch interactive-outline", { active: _ctx.modelValue }]),
    tabindex: "0",
    onKeydown: [
      _withKeys(_withModifiers(toggleValue, ["prevent"]), ["enter"]),
      _withKeys(_withModifiers(toggleValue, ["prevent"]), ["space"])
    ],
    onClick: toggleValue,
    ref_key: "toggleContainer",
    ref: toggleContainer
  }, [
    _createElementVNode("div", {
      class: "toggle-background-slider",
      style: _normalizeStyle(sliderStyle.value),
      ref_key: "slider",
      ref: slider
    }, null, 4),
    _createElementVNode("div", {
      class: _normalizeClass(["toggle-option left", { active: _ctx.modelValue }]),
      ref_key: "leftOption",
      ref: leftOption
    }, _toDisplayString(_ctx.leftLabel), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["toggle-option right", { active: !_ctx.modelValue }]),
      ref_key: "rightOption",
      ref: rightOption
    }, _toDisplayString(_ctx.rightLabel), 3),
    _createElementVNode("input", {
      type: "checkbox",
      id: inputId.value,
      checked: _ctx.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (
        _ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).checked)
      )),
      style: {"display":"none"}
    }, null, 40, _hoisted_2)
  ], 42, _hoisted_1))
}
}

})